export default {
  num_encoder_tokens: 162,
  num_decoder_tokens: 430,
  encoder_max_seq_length: 9,
  decoder_max_seq_length: 4,
};
